<div class="modal-header">
  <h4 class="col-11 modal-title">
    <img alt="Brand" src="{{directoryImages}}/assets/images/dhl-official2.png">
  </h4>
  <button type="button" [focus] class="close" [focus] data-dismiss="modal" aria-hidden="true" (click)="modalRef.hide()">×</button>
</div>
<div class="modal-body">
  {{'Shared.Reference' | translate}} {{packageInfo.LicensePlate}}
  <tracking [tracking]="packageInfo.Tracking"></tracking>
</div>
